/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для страницы всех подарков.
   * Создаёт вид для каждого отдельного подарка внутри себя.
   *
   * @param el {string} jQuery-селектор родительского элемента
   * @param itemEl {string} jQuery-селектор элемента товара
   */
  app.GiftsPageView = app.View.extend({
    el: '.all-gifts',
    itemEl: '.gift-item',
    itemViews: [],
    
    beforeRun: function () {
      var that = this;
      this.$items = $(this.itemEl);
      _.each(this.$items, function (item) {
        // подключаем таймер
        that.startTimer(item);
      });
    },
    
    startTimer: function (item) {
      var that = $(item),
        $time = that.find('time');
      
      $time.countdown(new Date($time.attr('data-date')), function (event) {
        that.find('.days', $time).html(event.strftime('%D'));
        that.find('.hours', $time).html(event.strftime('%H'));
        that.find('.minutes', $time).html(event.strftime('%M'));
      });
    }
  });
})(jQuery);

}.call(window));